export default {
  row: {
    display: 'flex',
    gap: '20px',

    '& .MuiPaper-root': {
      background: '#fff !important',
    },
    '& .MuiAutocomplete-listbox': {
      padding: '0 !important',
    },
    '& .MuiPopper-root': {
      padding: '0 !important',
      background: '#fff !important',
    },
  },
  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: '8px',
    marginTop: '8px',
  },
  addressListbox: {
    maxHeight: 300,
    width: 'auto',
    padding: 0,
  },
  autocompleteOption: {
    whiteSpace: 'nowrap',
    padding: '4px 8px !important',
    lineHeight: '1.5',
    margin: 0,
  },
  autocompleteListbox: {
    margin: 0,
    padding: 0,
  },
};
